import React, { useContext } from 'react';
import { isEmpty } from 'lodash';
import { BsArrowRight, BsArrowLeft } from 'react-icons/bs';
import DatePickerContext from '../context/DatePickerContext';
import {
  Container,
  Subtitle,
  Title,
  NavigateWrapper,
  NavigateBtn,
  NavigateLabel,
  TitleContainer,
  ListingIconsWrapper,
  ListView,
  GridView,
  Spacing,
} from './styles/ListingEvents.styled';
import GridIcon from './GridIcon';
import ListIcon from './ListIcon';
import SearchEventContext from '../context/SearchEventContext';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';

export default function EventsListingHeader({ dir }) {
  const isArabic = dir === 'rtl';
  const { translations } = useContext(DWTCContext);
  const { year, setYear, months, month, setMonth } = useContext(DatePickerContext);
  const { listing, setListing, totalFilteredEvents, eventsList } = useContext(SearchEventContext);
  const [subtitle, setSubtitle] = React.useState(
    isArabic
      ? `(${totalFilteredEvents || 0} فعاليات)`
      : `(${totalFilteredEvents || 0} ${totalFilteredEvents === 1 ? 'event' : 'events'})`,
  );

  const monthsFull = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  };

  const prevMonthTernary = +month <= 1 ? 12 : +month - 1;
  const nextMonthTernary = +month >= 12 ? 1 : +month + 1;
  const next = isArabic
    ? getTranslationByKey(translations, months[nextMonthTernary])
    : months[nextMonthTernary];
  const prev = isArabic
    ? getTranslationByKey(translations, months[prevMonthTernary])
    : months[prevMonthTernary];
  const title = `${
    isArabic ? getTranslationByKey(translations, monthsFull[month]) : monthsFull[month]
  } ${year} `;

  React.useEffect(() => {
    setSubtitle(
      isArabic
        ? `(${totalFilteredEvents || 0} فعاليات)`
        : `(${totalFilteredEvents || 0} ${totalFilteredEvents === 1 ? 'event' : 'events'})`,
    );
  }, [eventsList]);

  // console.log('eventsList', eventsList);

  const handleClickPrev = () => {
    if (+month <= 1) setYear(+year - 1);
    setMonth(prevMonthTernary);
  };
  const handleClickNext = () => {
    if (+month >= 12) setYear(+year + 1);
    setMonth(nextMonthTernary);
  };

  return (
    <Container dir={dir}>
      {isEmpty(eventsList) ? (
        <Spacing />
      ) : (
        <ListingIconsWrapper>
          <ListView>
            <ListIcon selected={listing === 'listpress'} setValue={setListing} />
          </ListView>
          <GridView>
            <GridIcon selected={listing === 'grid'} setValue={setListing} />
          </GridView>
        </ListingIconsWrapper>
      )}
      <TitleContainer>
        <Title dir={dir}>{title}</Title>
        <Subtitle dir={dir}>{subtitle}</Subtitle>
      </TitleContainer>
      <NavigateWrapper>
        <NavigateBtn onClick={() => handleClickPrev()} dir={dir}>
          <BsArrowLeft className="arrow" />
          <NavigateLabel dir={dir}>{prev}</NavigateLabel>
        </NavigateBtn>
        <NavigateBtn onClick={() => handleClickNext()} dir={dir}>
          <NavigateLabel dir={dir}>{next}</NavigateLabel>
          <BsArrowRight className="arrow" />
        </NavigateBtn>
      </NavigateWrapper>
    </Container>
  );
}
